<template>
  <div class="wrapper main-container">
    <loading :isShow="listLoading" />
    <Tabs v-model="selTab" :animated="false" @on-click="changeTab">
      <Button @click="back($route.query.backUrl || '')" ghost type="primary" slot="extra" style="margin-right: 10px; min-width: 88px">返回</Button>
      <Button
        v-if="selTab == 1 || selTab == 6 || (selTab == 3 && selSecTab == 3 && productForm.dockChannel != 3)"
        type="primary"
        style="width: 88px"
        @click="saveForm(true)"
        slot="extra"
        >保存</Button
      >
      <TabPane label="基本信息" name="1">
        <baseInfo
          ref="baseInfo"
          @success="refreshProduct"
          :additionals="additionals"
          :gradeAdditions="gradeAdditions"
          :filingInformations="filingInformations"
        ></baseInfo>
      </TabPane>
      <TabPane label="内容管理" name="3">
        <div class="tab-wrap">
          <span :class="{ 'active': selSecTab == 3 }" @click="changeTab2(3)">产品详情</span>
          <span :class="{ 'active': selSecTab == 1 }" @click="changeTab2(1)">文档资料</span>
          <span :class="{ 'active': selSecTab == 2 }" @click="changeTab2(2)">产品海报</span>
          <span :class="{ 'active': selSecTab == 4 }" @click="changeTab2(4)">投保流程</span>
        </div>
        <productManageRecourse v-show="selSecTab == 1" :edit="true" :productForm="productForm"> </productManageRecourse>
        <newProductManagePoster v-show="selSecTab == 2" :edit="true" :productForm="productForm"></newProductManagePoster>
        <!-- 产品详情 -->
        <detailInfo ref="detailInfo" v-show="selSecTab == 3"></detailInfo>
        <!-- 投保流程 -->
        <product-process ref="productProcess" v-show="selSecTab == 4"></product-process>
      </TabPane>
      <TabPane v-if="productForm.id && $route.name != 'productManager.productAdd'" label="代理协议" name="4">
        <agreementList ref="agreementList" :productForm="productForm"></agreementList>
      </TabPane>
      <TabPane label="回执回访指引" name="6">
        <Form :model="productForm" ref="productFormRef1" class="page-form" :rules="productFormRules" :label-width="140">
          <FormItem label="回执要求" prop="receiptStatus" :rules="$units.formRule.required('请选择')" class="full">
            <RadioGroup v-model="productForm.receiptStatus">
              <Radio label="0">需要回执</Radio>
              <Radio label="-1">无需回执</Radio>
              <Radio label="1">回执成功</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="回执操作流程" prop="receiptDesc" class="two" v-if="productForm.receiptStatus == '0'">
            <Input type="textarea" :autosize="{ minRows: 3, maxRows: 16 }" v-model="productForm.receiptDesc" placeholder="请输入" />
          </FormItem>
          <FormItem label="回访要求" prop="revisitStatus" :rules="$units.formRule.required('请选择')" class="full">
            <RadioGroup v-model="productForm.revisitStatus">
              <Radio label="0">需要回访</Radio>
              <Radio label="-1">无需回访</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="回访操作流程" prop="revisitDesc" class="two" v-if="productForm.revisitStatus == '0'">
            <Input type="textarea" :autosize="{ minRows: 3, maxRows: 16 }" v-model="productForm.revisitDesc" placeholder="请输入" />
          </FormItem>
        </Form>
      </TabPane>
      <!-- 添加v-if避免顺序错乱 -->
      <TabPane label="上游结算规则" name="7" v-if="!listLoading || productForm.id">
        <settlement-desc ref="settlementDesc1"></settlement-desc>
      </TabPane>
      <TabPane label="对下结算规则" name="8" v-if="!listLoading || productForm.id">
        <settlement-desc ref="settlementDesc2" type="downstream"></settlement-desc>
      </TabPane>
    </Tabs>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import baseInfo from './components/baseInfo';
import agreementList from './components/agreementList';
import newProductManagePoster from './components/newProductManagePoster';
import productManageRecourse from './components/productManageRecourse';
import detailInfo from './components/detailInfo';
import productProcess from './components/productProcess';
import settlementDesc from './components/settlementDesc';
import { productEditMixin } from './form/productEditMixin';
export default {
  components: {
    baseInfo,
    detailInfo,
    productProcess,
    settlementDesc,
    agreementList,
    newProductManagePoster,
    productManageRecourse
  },
  mixins: [productEditMixin, common],
  data() {
    return {
      productInsureAreas: [], //投保区域
      productForm: {
        themeIds: [],
        showThemeIds: [],
        publishStatus: '1'
      },
      productFormRules: {},
      listLoading: false,
      isCopy: false,
      id: '',
      pageNo: 1,
      pageSize: 10,
      formDateEdit: [],
      selTab: '1',
      selSecTab: '3',
      isShowAdd: false,
      columns: [
        {
          title: '序号',
          type: 'index',
          align: 'center'
        },
        {
          title: '附加险信息',
          key: 'addName',
          align: 'center'
        },
        {
          title: '附加险code',
          key: 'addCode',
          align: 'center'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action'
        }
      ],
      form: {
        items: [
          {
            question: '',
            answer: ''
          }
        ]
      },
      // 产品分类
      ProductThemeList: [],
      additionals: [], //附加险
      gradeAdditions: [], //档次/计划
      filingInformations: [] //备案信息
    };
  },
  created() {
    this.selTab = this.$route.query.tab || '1';
    this.id = this.$route.query.id; //产品id
    this.isCopy = this.$route.query.isCopy == 1; //是否为复制协议
    if (!this.id) {
      this.listLoading = false;
      this.initData();
    } else {
      //详情
      this.getDetail();
    }
  },
  activated() {},
  methods: {
    refreshProduct(data) {
      this.id = data.id;
      this.isCopy = false;
      this.getDetail();
    },
    async changeTab() {
      //切换非表单页进行必填校验
      if (!(this.selTab == 1 || (this.selTab == 3 && this.selSecTab == 3))) {
        // 存在异常时自动切换到对应tab
        const isok = await this.saveForm(false);
        if (!isok) {
          return;
        }
      }
    },
    changeTab2(selSecTab) {
      this.selSecTab = selSecTab;
      this.changeTab();
    },
    async saveForm(notice = false) {
      try {
        if (this.selTab == '6' && this.productForm.id && notice) {
          this.$refs.productFormRef1.validate(async valid => {
            if (valid) {
              this.listLoading = true;
              const formData = await this.$refs.baseInfo.checkForm();
              await this.$refs.detailInfo.checkForm(formData);
              if (this.productForm.receiptStatus != '0') {
                delete this.productForm.receiptDesc;
              }
              if (this.productForm.revisitStatus != '0') {
                delete this.productForm.revisitDesc;
              }
              await this.$refs.baseInfo.saveForm(formData, notice, res => {
                if (res.id) {
                  this.id = res.id;
                  this.productForm.id = res.id;
                  this.productForm.productCode = res.productCode;
                  this.productForm.productCategory = res.productCategory;
                }
              });
            } else {
              this.$Message.warning('请正确填写表单');
              return;
            }
          });
        } else {
          this.listLoading = true;
          const formData = await this.$refs.baseInfo.checkForm();
          await this.$refs.detailInfo.checkForm(formData);
          await this.$refs.baseInfo.saveForm(formData, notice, res => {
            if (res.id) {
              this.id = res.id;
              this.productForm.id = res.id;
              this.productForm.productCode = res.productCode;
              this.productForm.productCategory = res.productCategory;
            }
          });
        }
      } catch (errData) {
        // 存在异常切换到对应tab
        if (Object.hasOwnProperty.call(errData, 'selTab')) {
          this.selTab = errData.selTab;
          this.selSecTab = errData.selSecTab || 3;
        } else {
          this.selTab = '1';
        }
        return false;
      } finally {
        this.listLoading = false;
      }
      return true;
    },
    async getDetail() {
      this.listLoading = true;
      const res = await this.$http({
        url: '/buz/productBase/read/detail/v2',
        type: 'GET',
        data: { id: this.id }
      });
      const productForm = res.data.productBase;
      productForm.baseSalesNum = productForm.baseSalesNum ? productForm.baseSalesNum : '';
      this.additionals = res.data.additionals || []; //附加险
      this.gradeAdditions = res.data.gradeAdditions || []; //档次/计划
      this.productInsureAreas = res.data.productInsureAreas || []; //区域
      this.filingInformations = res.data.filingInformations || []; //附加险
      if (productForm.goodness) {
        try {
          if (productForm.goodness.indexOf('[') != -1) {
            productForm.goodness = JSON.parse(productForm.goodness);
          } else {
            productForm.goodness = productForm.goodness.replace(/<br>/g, '\n').split(/[\n]/);
          }
        } catch (error) {
          productForm.goodness = productForm.goodness.replace(/<br>/g, '\n').split(/[\n]/);
        }
      } else {
        productForm.goodness = [];
      }
      if (productForm.titleLabel) {
        try {
          if (productForm.titleLabel.indexOf('[') != -1) {
            productForm.titleLabel = JSON.parse(productForm.titleLabel);
          } else {
            productForm.titleLabel = productForm.titleLabel.split(',');
          }
        } catch (error) {
          productForm.titleLabel = productForm.titleLabel.split(',');
        }
      } else {
        productForm.titleLabel = [];
      }
      // 处理历史数据，转为为数组
      if (!isNaN(productForm.sellType)) {
        productForm.sellType = `[${productForm.sellType}]`;
      }
      if (!isNaN(productForm.insureType)) {
        productForm.insureType = `[${productForm.insureType}]`;
      }
      try {
        // 未配置时默认类型1 自投 网销
        productForm.sellType = productForm.sellType && productForm.sellType != '[]' ? JSON.parse(productForm.sellType) : ['1'];
        productForm.insureType = productForm.insureType && productForm.insureType != '[]' ? JSON.parse(productForm.insureType) : ['1'];
      } catch (error) {
        productForm.sellType = ['1'];
        productForm.insureType = ['1'];
      }
      if (productForm.sellType.length) {
        productForm.sellTypeOne = productForm.sellType[0];
      } else {
        productForm.sellTypeOne = '1';
      }
      productForm.productMainType = '1';
      productForm.salesStatus = productForm.salesStatus || '1';
      // productForm.supplierType = productForm.supplierType || '1';
      productForm.regulatoryThemeId = productForm.regulatoryThemeId ? productForm.regulatoryThemeId.split(',') : [];
      productForm.earliestRenewalDay = productForm.earliestRenewalDay && productForm.earliestRenewalDay.toString();
      productForm.latestRenewalDay = productForm.latestRenewalDay && productForm.latestRenewalDay.toString();
      productForm.themeIds = [];
      productForm.showThemeIds = [];
      this.$nextTick(() => {
        this.listLoading = false;
        this.productForm = productForm;
        this.initData();
      });
    },
    initData() {
      this.$nextTick(async () => {
        const productForm = await this.$refs.baseInfo.init(this.productForm, this.isCopy, this.productInsureAreas);
        this.$refs.detailInfo.init(productForm);
        // 投保流程
        if (this.selTab == 3 && this.selSecTab == 4) {
          this.$refs.productProcess.init(this.productForm);
        }
        // 结算规则
        if (this.selTab == 7) {
          this.$refs.settlementDesc1.init(this.productForm);
        }
        if (this.selTab == 8) {
          this.$refs.settlementDesc2.init(this.productForm);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/.ivu-tabs {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);

  .ivu-tabs-bar {
    flex: 0 0 40px;
  }

  .ivu-tabs-content {
    flex: 1;
    overflow-y: scroll;
    overflow-x: hidden;
    padding-bottom: 50px;
  }
}

.tab-wrap {
  // border-bottom: 1px solid #ececec;
  span {
    cursor: pointer;
    padding: 6px 0 6px;
    margin-right: 44px;
    font-size: 13px;
    color: #515c6f;
    display: inline-block;
  }

  .active {
    position: relative;
    color: #236dff;
    // border-bottom: 2px solid #236dff;
  }
}

.page-form {
  margin-top: 15px;
  margin-bottom: 30px;
}

/deep/.board {
  height: 280px;
  overflow-y: scroll;
  overflow: hidden;
}

.wrapper {
  flex-direction: column;

  .form-body {
    margin-top: 20px;

    .productForm {
      .ivu-form-item {
        width: calc((100% - 30px) / 3);
      }
    }
  }

  /deep/ .btn {
    color: #236dff;
    float: left;
    margin-right: 20px;

    &:hover {
      cursor: pointer;
    }
  }

  .inner {
    display: flex;

    > span {
      margin-right: 30px;
    }

    /deep/ .ivu-input-wrapper {
      width: 80%;
    }
  }

  /deep/ {
    .ivu-tabs-bar {
      border-bottom: 1px solid #ececec;
    }

    .ivu-tabs-ink-bar {
      display: none;
    }

    .ivu-tabs-tab {
      padding: 9px 0 10px;
      margin-right: 44px;
      font-size: 14px;
      color: #515c6f;
    }

    .ivu-tabs-tab-active {
      position: relative;
      color: #236dff;

      &::before {
        content: '';
        position: absolute;
        left: 0;
        bottom: 1px;
        height: 2px;
        width: 100%;
        background-color: #236dff;
      }
    }
  }
}
</style>
